import { i18n } from '../translations/i18n';
import { USER_CONFIG_FETCHED } from '@alphapoint/apex-web/lib/redux/actions/userActions';

const languageMiddleware = () => (next) => (action) => {
  if (action.type === USER_CONFIG_FETCHED) {
    const language = action.payload.find((o) => o.Key === 'Language')?.Value;
    if (language && i18n.resolvedLanguage !== language) {
      i18n.changeLanguage(language);
    }
  }
  return next(action);
};

export default languageMiddleware;
